import { useState } from "react";
import DialogFormPanel from "../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../shared/components/button/CreateButtonTrigger";
import CreateRoleForm from "./CreateRoleForm";

const CreateRoleDialog = ({ onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="Alta nuevo rol"
      description="Crear un nuevo rol en el sistema"
      content={<CreateRoleForm onSubmitHandler={onSubmit} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateRoleDialog;
